import axios from 'axios';

export interface IResponse<T = any> {
  code: number;
  data: T;
  result: T;
  msg: string;
  success?: string;
  message?: string;
  /** 时间戳 */
  timestamp?: string;
  total?: number;
}

export interface IMessage {
  level: EN_MESSAGE_LEVEL;
  content: string;
  status: EN_MESSAGE_STATUS;
  timestamp: number;
}

export enum EN_MESSAGE_LEVEL {
  INFO = 'info',
  WARNING = 'warning',
  ERROR = 'error',
}

export enum EN_MESSAGE_STATUS {
  UNREAD = 'unread',
  READ = 'read',
}

/** 暂时用不到 */
type KV = { [k: string]: any };

/**
 *  获得接口，根据投图功能复用
 */
class MessageServiceImp {
  public async rawGet<T = void>(url: string): Promise<T> {
    const { data: response } = await axios.get<T>(url);
    return response;
  }

  // 没有用到，后续大概率也不会用
  public async rawPost<T = void>(url: string, params: KV = {}): Promise<T> {
    const { data: response } = await axios.post<T>(url, params);
    return response;
  }

  public async getMessage(): Promise<IMessage | undefined> {
    const url = `${window.ENV_CONFIG.nodeWebUrl}/message`;
    if (window.ENV_CONFIG.env === 'production') {
      const { code, result } = await this.rawGet<IResponse<IMessage>>(url);
      if (code !== 200) {
        throw new Error('getMessage error');
      }
      return result;
    }
  }

  public async sendMessage(msg: IMessage): Promise<boolean> {
    const url = `${window.ENV_CONFIG.nodeWebUrl}/message`;
    const { code, result } = await this.rawPost<IResponse<boolean>>(url, msg);
    if (code !== 200) {
      return false;
    }
    return result;
  }

  public async clearMessage(): Promise<boolean> {
    const url = `${window.ENV_CONFIG.nodeWebUrl}/message/clear`;
    const { code, result } = await this.rawPost<IResponse<boolean>>(url);
    if (code !== 200) {
      return false;
    }
    return result;
  }
}

export const MessageService = new MessageServiceImp();
